module.exports = __webpack_public_path__ + "img/operator-mono-dark.ebe8efd3.png";